import { Clock, RefreshCw } from 'lucide-react';

const actionColorFor = (action = '') =>
  action.includes('created') ? '#16a34a' :
  action.includes('deleted') ? '#ef4444' :
  action.includes('reminder') ? '#8b5cf6' :
  action.includes('escalation') ? '#f97316' :
  action.includes('paused') ? '#f59e0b' :
  action.includes('version') ? '#3b82f6' : '#6b7280';

export const AuditTab = ({ auditLog, loadAudit }) => (
  <div className="flex-1 overflow-y-auto p-6">
    <div className="flex items-center justify-between mb-4">
      <h2 className="text-sm font-bold text-gray-800">Audit Log</h2>
      <button onClick={loadAudit} className="text-xs text-gray-400 hover:text-gray-600 flex items-center gap-1"><RefreshCw size={10} /> Refresh</button>
    </div>
    {auditLog.length === 0 && (
      <div className="text-center py-16">
        <Clock size={28} className="mx-auto text-gray-300 mb-2" />
        <p className="text-gray-400 text-sm">No audit entries yet</p>
      </div>
    )}
    <div className="space-y-1" data-testid="audit-log-list">
      {auditLog.map(entry => {
        const actionColor = actionColorFor(entry.action);
        return (
          <div key={entry.id} className="flex items-start gap-3 px-4 py-3 rounded-lg border border-gray-100 hover:bg-gray-50/50" data-testid={`audit-${entry.id}`}>
            <div className="w-2 h-2 rounded-full mt-1.5 flex-shrink-0" style={{ backgroundColor: actionColor }} />
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="text-[10px] font-bold px-2 py-0.5 rounded text-white" style={{ backgroundColor: actionColor }}>
                  {(entry.action || '').replace(/_/g, ' ').toUpperCase()}
                </span>
                <span className="text-xs text-gray-700 font-medium">{entry.user_name || 'System'}</span>
              </div>
              {entry.details && (
                <div className="mt-1 flex items-center gap-2 flex-wrap text-[10px] text-gray-500">
                  {entry.details.carrier && <span>{entry.details.carrier}</span>}
                  {entry.details.title && <span>{entry.details.title}</span>}
                  {entry.details.doc_id && <span className="text-gray-400">{entry.details.doc_id.slice(0, 20)}</span>}
                  {entry.details.reminder_count != null && <span>Reminder #{entry.details.reminder_count}</span>}
                  {entry.details.is_escalation && <span className="text-orange-600 font-bold">ESCALATED</span>}
                  {entry.details.filename && <span>{entry.details.filename}</span>}
                </div>
              )}
              <p className="text-[9px] text-gray-400 mt-0.5">{new Date(entry.created_at).toLocaleString()}</p>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);
